import { useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";
import PVInvoiceReport from "./PVInvoiceReport";
import CreatedTimesheetsReport from "./CreatedTimesheetsReport";
import { SVCreatedInvoiceReport } from "./SVCreatedInvoiceReport";

type TabKey = "timesheet" | "pv_invoice" | "sv_invoice";

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: "timesheet", label: "Timesheet", icon: "pi pi-clock" },
  { key: "pv_invoice", label: "PV Invoice", icon: "pi pi-file" },
  { key: "sv_invoice", label: "SV Invoice", icon: "pi pi-file-edit" },
];

const US_Account_Created_Report = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("timesheet");
  const [filter, setFilter] = useState<any>();
  const [groupName, setGroupName] = useState<string | null>(null);

  const renderContent = () => {
    switch (activeTab) {
      case "timesheet":
        return <CreatedTimesheetsReport filter={filter} groupName={groupName} />;
      case "pv_invoice":
        return <PVInvoiceReport filter={filter} groupName={groupName} />;
      case "sv_invoice":
        return <SVCreatedInvoiceReport filter={filter} groupName={groupName} />;
    }
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" />
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filter={filter} setFilter={setFilter} setGroupName={setGroupName} />
        </AccordionTab>
      </Accordion>

      <div style={{ display: "flex", flexDirection: "row", gap: "4px", marginTop: "8px", borderBottom: "2px solid #dee2e6" }}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "9px 18px",
                border: "none",
                borderBottom: isActive ? "2px solid #3B82F6" : "2px solid transparent",
                borderRadius: "0",
                cursor: "pointer",
                fontWeight: isActive ? "700" : "500",
                fontSize: "13px",
                backgroundColor: "transparent",
                color: isActive ? "#3B82F6" : "#374151",
                marginBottom: "-2px",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
            >
              <i className={tab.icon} style={{ fontSize: "14px" }} />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div style={{ marginTop: "8px" }}>{renderContent()}</div>
    </>
  );
};

export default US_Account_Created_Report;
